import { useContext } from 'react';
import { Button } from '@givebutter/primitives/button';
import { FilterGroupContext } from 'components/filter/filters-next/FilterGroupContext';
import { FilterProviderContext } from 'components/filter/filters-next/FilterProvider';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { useFiltersCache } from 'contexts/useFiltersCache';

const DeleteGroupButton = () => {
    const { cacheKey } = useContext(FilterProviderContext);
    const { groupId } = useContext(FilterGroupContext);
    const { currentGroup, filterGroups } = useFiltersByKey(cacheKey, groupId);
    const updateFilter = useFiltersCache(state => state.updateFiltersNextByKey);

    if (!filterGroups) {
        return null;
    }

    return (
        <Button
            size={'sm'}
            color={'neutral'}
            variant={'outline'}
            onClick={() =>
                updateFilter(
                    cacheKey,
                    filterGroups.filter(f => f.id !== currentGroup?.id),
                )
            }
        >
            Remove
        </Button>
    );
};

export { DeleteGroupButton };
